<template>
	<div>
		<layout-8
			:table_name="'Job Orders'"
			:filter_options=filters
			:id=pageid
			:searchbar=true
			:navbar=true
			:nav_items="['Save']"
			:nav_item_perms="['44']"
			:button_perm="'44'"
			:button_name="'Select'"
			:term=term
			:reroute="'/0310'"
			:select_reroute=true
			style="width:100%; height:calc(100vh - 50px);"
		></layout-8>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.SCHEDULING_PAGE,
			filters:[
				{name:"LocalOffice", options:["LAX","OAK","SZX","YVR","Korea","SHA","SEA","HAM", "Other"], value:[true,true,true,true,true,true,true,true,true], permission:['45','46','47','48','49','50','107','108','51']},
				{name:"Status", options:["Open","Completed","Cancelled"], value:[true,true,false], permission:['52','53','54']},
				{name:"Date", options:["Start","End"], value:['',''], permission:null},
			]
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Scheduling.vue